import { Routes, Route, Navigate } from 'react-router-dom';
import './styles/App.css';
import Navbar from './components/navbar/navbar';
import Contact from './pages/pages-contact/contact';
import Portfolio from './pages/pages-portfolio/portfolio';
import Services from './pages/page-services/services';
import React, { useState } from 'react';
import HomePage from './pages/pages-home/HomePage';
import AboutPage from './pages/pages-about/AboutPage';
import Footer from './components/footer/footer';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  return (
    <div className="app">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />        
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/servicios" element={<Services />} />
        <Route path="/nosotros" element={<AboutPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;

